enum IdentityType {
    Guest,
    UsernamePassword,
    ActiveDirectory,
    OAuth,
}

export default IdentityType;
